import api from './url';
import axios from 'axios';
import { Message } from 'element-ui'
import router from '@/router'
import Cookies from "js-cookie";
import { AESEncrypt, AESDecrypt } from '@/utils/secret.js'

let isSerect = true		//是否加密，xue：部署正式环境是需要为true

// 跳过加密的接口
const skipEncrypt = []

const serve = axios.create({
	baseURL: api.baseurl,
	withCredentials: false, // send cookies when cross-domain requests
	timeout: 1000 * 60 * 30, // request timeout
})

serve.interceptors.request.use(
	(config) => {
		// console.log(config)
		if(isSerect){
			if(skipEncrypt.includes(config.url)){
				return config
			}else{
				config.data = {encryptedData:AESEncrypt(config.data)}
				// console.log(AESDecrypt(config.data.encryptedData))
			}
		}

		config.headers['content-type'] = 'application/json'
		if (config.withoutToken) {} else {
			config.headers['Authorization'] = Cookies.get('token') ?
				Cookies.get('token') : null
		}
		return config
	},
	(error) => {
		return Promise.reject(error)
	})

serve.interceptors.response.use(
	response => {
		if(response.data.encryptedResponse){
			response.data = AESDecrypt(response.data.encryptedResponse)
		}
		if (response.data && (response.data.code === 401 || response.data.code === 600)) {
			// 如果响应中的数据存在，且响应数据的状态码为 401 或 600，表示令牌失效
			Message({
				message: '登录状态已过期，请重新登录',
				type: 'error',
				duration: 1500,
				onClose: () => {
					localStorage.clear(); // 清空本地存储
					sessionStorage.clear(); // 清空会话存储
					Cookies.remove('token');
					router.push('/'); // 跳转到登录页面
				}
			})
		} else if (response.data && response.data.code === 500) {
			// 如果响应中的数据存在，且响应数据的状态码为 500，表示服务器内部错误
			Message({
				message: response.data.msg,
				type: 'error',
				duration: 3000,
				onClose: () => {

				}
			})
			if (response.data.msg == '该账号未登录' || response.data.msg == '用户未登录') {
				localStorage.clear(); // 清空本地存储
				sessionStorage.clear(); // 清空会话存储
				router.push('/');
			}
		} else if (response.data && (response.data.code === 0||response.data.code === 508)) {
			// 402是登录接口角色错了，需要前端提示

		} else if (response.data.code === 10021) {
			// 登录过期
			localStorage.clear(); // 清空本地存储
			sessionStorage.clear(); // 清空会话存储
			Cookies.remove('token');
			router.push('/');
		} else if(response.data && !response.data.code){}else {
			Message({
				message: response.data.msg,
				type: 'error',
				duration: 1500,
				onClose: () => {

				}
			})
		}
		return response.data; // 返回响应数据部分
	},
	error => {
		return Promise.reject(error); // 以错误形式拒绝响应
	}
);
export default serve